import React, { useEffect } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import FinancingRequestStatusEnum from "../../../models/financing-request-status/FinancingRequestStatusEnum";

interface Props {
  statusId: FinancingRequestStatusEnum;
  statusName: string;
}

const useStyles = makeStyles((theme) => ({
  requestStatusElement: {
    textTransform: "uppercase",
    fontSize: "11px",
    lineHeight: "11px",
    padding: "6px 8px 6px 8px",
    borderRadius: "4px",
    fontWeight: 500,
    boxSizing: "border-box",
  },
  default: {
    color: "black",
    background: "white",
  },
  submitted: {
    color: "#E65100",
    background: "#FFE0B2",
  },
  approved: {
    color: "#006064",
    background: "#B9EBF2",
  },
  rejected: {
    color: "#F70029",
    background: "#FCD7DD",
  },
  returned: {
    color: "#263238",
    background: "#CFD8DC",
  },
  draft: {
    color: "#263238",
    background: "#CFD8DC",
  },
}));

export default function FinancingRequestStatusElement({
  statusId,
  statusName,
}: Props) {
  const classes = useStyles({});

  const getStatus = () => {
    let statusClassName = "";
    switch (statusId) {
      case FinancingRequestStatusEnum.Submitted:
        statusClassName = clsx(classes.requestStatusElement, classes.submitted);
        break;
      case FinancingRequestStatusEnum.Approved:
        statusClassName = clsx(classes.requestStatusElement, classes.approved);
        break;
      case FinancingRequestStatusEnum.Rejected:
        statusClassName = clsx(classes.requestStatusElement, classes.rejected);
        break;
      case FinancingRequestStatusEnum.Returned:
        statusClassName = clsx(classes.requestStatusElement, classes.returned);
        break;
      case FinancingRequestStatusEnum.Draft:
        statusClassName = clsx(classes.requestStatusElement, classes.draft);
        break;
      default:
        statusClassName = clsx(classes.requestStatusElement, classes.default);
    }

    return (
      <Typography component="span" className={statusClassName}>
        {statusName}
      </Typography>
    );
  };

  return getStatus();
}
